import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDXjfnD1sACqwCGP4SLhgEVBc-7JsV14QI",
  authDomain: "ott-webapp.firebaseapp.com",
  projectId: "ott-webapp",
  storageBucket: "ott-webapp.appspot.com",
  messagingSenderId: "730175574828",
  appId: "1:730175574828:web:f68000456505beae901289"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

export { auth, db, createUserWithEmailAndPassword, signInWithEmailAndPassword };
export default firebaseApp;